// extracted by mini-css-extract-plugin
export var centeredContent = "v_bm";
export var heroWithTitle = "v_bj";
export var pageContent = "v_t";
export var starIcon = "v_bl";
export var subtitleContainer = "v_bk";
export var titleContainer = "v_6";